<template>
<v-form>
  <v-card>
    <v-card-text
      class="pt-4"
      style="position: relative;"
    >
      <v-container>
        <v-layout align-center justify-center column >
          <v-fade-transition leave-absolute>
            <v-avatar
              color="transparent"
              size="120">
              <img :src="require('@/assets/logomarca.png')" alt="trevor">
            </v-avatar>
          </v-fade-transition>
          <v-flex xs12 class="pb-3">
            <h3 class="display-1 font-weight-light grey--text mb-2">Buscar Cliente</h3>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-select
              v-model="filter"
              :items="[
                {text: 'CPF', value: 'pessoa__cpf'},
                {text: 'Telefone', value: 'pessoa__telefone__icontains'},
                {text: 'Nome', value: 'pessoa__nome__icontains'},
                {text: 'Email', value: 'pessoa__email__icontains'},
                {text: 'Número de identificação', value: 'pessoa'}
              ]"
              item-text="text"
              return-object
              label="Escolha uma opção de pesquisa"
              outline
            />
            <v-text-field
              v-show="filter"
              v-model="busca"
              outline
              clearable
              :label="`${filter.text} do cliente`"
              :mask="filter.text === 'CPF' || filter.text === 'Telefone' ? `${filter.text === 'CPF' ? '###.###.###-##' : '(##) # ####-####'}`: ''"
              type="text"
            >
            </v-text-field>
          </v-flex>

        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions color="red" class="info">
        <v-spacer></v-spacer>
        <v-btn flat dark @click.prevent="consultar">
        consultar
          <v-icon right>find_replace</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</v-form>
</template>

<script>

export default {
  data () {
    return {
      step: 1,
      filter: '',
      busca: null
    }
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    }
  },
  methods: {
    fechar () {
      this.busca = null
      this.$emit('fechar')
    },
    consultar () {
      this.$emit('consultar', { filter: this.filter.value, value: this.busca })
      this.fechar()
    }
  }
}
</script>
